<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

        <div class="content" v-else>
            <h1>Blog</h1>
            <v-layout class="layout--controls">
                <v-btn
                        color="primary"
                        type="submit"
                        class="button--top control"
                        @click="addArticle()"
                >Vytvořit článek</v-btn>
                <v-select
                        :items="articleAuthors"
                        item-value="id"
                        item-text="name"
                        label="Filtrovat podle autora"
                        clearable
                        outlined
                        class="input--search control"
                        v-model="selectedAuthorId"
                ></v-select>
            </v-layout>
            <v-layout class="table-items">



                <v-data-table

                    locale="cs"
                        :headers="headers"
                        :items="filteredItems"
                        :search="search"
                        :loading="false"
                        item-key="name"
                        :items-per-page="30"
                        :mobile-breakpoint='0'
                        class="elevation-1 full-width frankjoy-table"
                >

                    <template slot="body" slot-scope="props">
                        <tbody>
                        <tr v-for="item in props.items" :key="item.id" >
                            <router-link :to="{name:'BlogDetail', params: {id: item.id}}" >
                                <td class="image-table-blog">
                                    <span v-if="item.image" class="image-table image-table--photo" :style="'background-image:url('+item.image+')'"></span>
                                    <span v-else class="image-table"></span>
                                </td>
                                <td class="">{{item.id}}</td>
                                <td class="">{{item.name}}</td>
                                <td class="">{{item.slug}}</td>
                                <td class="">{{item.author_name}}</td>
                                <td class="small bold">
                                    <span v-if="item.published" class="published">ANO</span>
                                    <span v-else class="published published--not">NE</span>
                                </td>
                                <td class="small bold">
                                    <span class="seo seo--checked" v-if="item.seo">
                                        <v-icon>check</v-icon>
                                    </span>
                                    <span class="seo" v-else>

                                    </span>
                                </td>
                                <td class="right">
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            class="button--small"
                                    >Detail</v-btn>
                                </td>
                            </router-link>
                            <td class="right">
                                <a
                                        :href="frontendUrl + '/blog/' + item.slug"
                                        target="_blank"
                                        class="button--small"
                                        @click.stop
                                >Zobrazit na webu</a>
                            </td>
                        </tr>
                        <div v-if="props.items.length == 0" class="text-no-results">
                            <p>Žádný článek nebyl nalezen</p>
                        </div>
                        </tbody>

                    </template>


                    <template slot="footer" slot-scope="totals">

                        <div class="table-footer"  v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
                            <div class="table-footer__text">
                                Počet článků na stránce
                            </div>
                            <div class="table-footer__pages">
                                <span v-if="totals.props.pagination.pageStop > 0"><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart + 1}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                                <span v-else><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                            </div>
                        </div>
                    </template>
                </v-data-table>


            </v-layout>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    export default {
        name: 'Blog',
        components: {
        },



        data() {
            return {
                loaded: false,
                search: '',
                headers: [
                    //  { text: '', value: '',  align: 'left',sortable: false },
                    { text: '', value: 'image', sortable: false,  align: 'left',  },
                    { text: 'ID', value: 'id',  align: 'left',  },
                    { text: 'Název', value: 'name',  align: 'left',  },
                    { text: 'Slug', value: 'slug',  align: 'left',  },
                    { text: 'Autor', value: 'author_name',  align: 'left',  },
                    { text: 'Publikováno', value: 'published',  align: 'left',  },
                    { text: 'SEO', value: 'seo',  align: 'left',  },
                    { text: '', value: 'controls',  align: 'right',  },
                    { text: '', value: 'frontend',  align: 'right',  }
                ],
                items: [],
                articleAuthors: [],
                selectedAuthorId: null,
                frontendUrl: process.env.VUE_APP_FRONTEND_URL,

            }
        },

        created() {


            this.fetchData();
            this.fetchArticleAuthors();

        },
        computed: {
            ...mapState(['profile']),
            filteredItems(){
                if(!this.selectedAuthorId){
                    return this.items;
                }
                return this.items.filter((item) => item.author_id === this.selectedAuthorId);
            },
        },
        mounted(){
        },
        methods: {

            addArticle(){
                this.$router.push({name: 'BlogDetail', params: {id: 'add'}})
            },
            formatCreatedAt(date){
                if(date){
                    return moment(date).format('D.M.YYYY');
                }else{
                    return null;
                }

            },
            fetchData(){

                this.$axios.get('/admin/articles').then((response) => {
                    this.items = response.data.articles;
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            fetchArticleAuthors(){
                this.$axios.get('/admin/article-authors').then((response) => {
                    this.articleAuthors = response.data.authors;
                });
            }
        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
